import {
  ButtonType,
  CrudTableViewConfig,
  CrudViewColumnType,
  ActionBehavior,
  AlertTypes,
  HeadingType,
  AlertConfig,
  TypographyConfig,
  FontWeight,
  TextMode
} from '@rappider/rappider-components/utils';
import { PATH_DEFINITIONS } from '../../definitions/path-definition';

export const PROJECT_LIST_CONFIG: CrudTableViewConfig = {
  defaultSearchField: 'name',
  columns: [
    {
      title: 'ID',
      fieldName: 'id',
      type: CrudViewColumnType.Text,
      visible: false
    },
    {
      title: 'Name',
      fieldName: 'name',
      type: CrudViewColumnType.ActionLink
    },
    {
      title: 'Created By',
      fieldName: 'createdBy',
      type: CrudViewColumnType.Text
    },
    {
      title: 'Created Date',
      fieldName: 'createdDate',
      type: CrudViewColumnType.Date
    }
  ],
  listActions: [
    {
      name: 'PROJECT_MODULE.PROJECT_CREATE_COMPONENT.PROJECT_CREATE',
      text: 'PROJECT_MODULE.PROJECT_CREATE_COMPONENT.PROJECT_CREATE',
      buttonType: ButtonType.Default,
      behavior: ActionBehavior.Route,
      icon: { name: 'fas fa-plus' },
      redirectUrl: `${PATH_DEFINITIONS.PROJECTS.PROJECT_CREATE_PATH}`
    }
  ],
  itemActions: [
    {
      text: 'SHARED.DELETE',
      name: 'DELETE_PROJECT',
      behavior: ActionBehavior.Emit,
      icon: { name: 'far fa-trash' }
    },
  ]
};

export const getProjectDeleteConfig = (projectName: string): AlertConfig => ({
  type: AlertTypes.Warning,
  title: {
    type: HeadingType.H5,
    content: 'Important Notice!'
  },
  description: {
    content: `You're about to delete the <b>${projectName}</b> project! <br><br>  This action is irreversible.Please be aware that this action will permanently delete all project-related data, including dependent resources and code, and remove all collaborator associations. Once deleted, this data cannot be recovered. <br><br>If you're absolutely sure you want to proceed, please confirm by typing the project name below. <br><br>We appreciate your careful consideration before taking this step!`,
    textMode: TextMode.Html
  },
  showIcon: true,
  closeable: false
});
